import { storyblokEditable, renderRichText } from "@storyblok/react";
import { Rocket, Map, HeartHandshake, ArrowRight } from "lucide-react";

const Intro = ({ blok }) => {
  return (
    <div
      {...storyblokEditable(blok)}
      className="font-display home-intro text-left"
    >
      {
        <div className="home-intro-container">
          <div className="home-intro-content">
            <small>{blok.tag}</small>
            <p className="home-intro-title">
              {blok.introtitle}
              <br />
              <span>{blok.introtitletwo}</span>
            </p>
            <div
              dangerouslySetInnerHTML={{
                __html: renderRichText(blok.subtitle),
              }}
            />
          </div>
          <div className="youtube-embed-container">
            <div className="video-responsive">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/dgcEvOeq9Cw?si=xjocLBBC2apxs4HD&amp;controls=0"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          {/* <div className="path">
            <div className="path-wrapper">
              <div className="icon-wrapper">
                <Rocket className="path-icon" size={32} />
              </div>
              <div className="path-detail">
                <h3>A Platform</h3>
                <p>
                  The tools and technology to turn their passion into powerful
                  fundraising campaigns that work seamlessly.
                </p>
              </div>
            </div>
            <div className="path-wrapper">
              <div className="icon-wrapper">
                <Map className="path-icon" size={32} />
              </div>
              <div className="path-detail">
                <h3>A Plan</h3>
                <p>
                  Clear guidance and proven strategies to help them navigate
                  from idea to impact with confidence.
                </p>
              </div>
            </div>
            <div className="path-wrapper">
              <div className="icon-wrapper">
                <HeartHandshake className="path-icon" size={32} />
              </div>
              <div className="path-detail">
                <h3>To know you're there</h3>
                <p>
                  The assurance that your organization stands behind them, ready
                  to support their journey every step of the way.
                </p>
              </div>
            </div>
          </div> */}
          <div className="intro-end">
            <h2>
              To learn how Catalyst can help your nonprofit thrive, book a demo
            </h2>
            <a className="button button-primary" href="/book-demo">
              Book your personal demo
              <ArrowRight size={24} fill="white" className="button-icon" />
            </a>
          </div>
          {/* <p className="home-intro-subtext">{blok.subtext}</p> */}
        </div>
      }
    </div>
  );
};

export default Intro;
